import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from "axios";
import { toast } from 'react-toastify';
import Loader from '../../../Loader';
import { updateProfile, userStore } from "../../../../redux/reduxStore.js"

const DeleteUserCompany = (props) => {
  const [loader, setLoader] = useState(false);
  const token = useSelector((state) => state.token);
  const user = useSelector((state) => state.user);
  const DeleteCompany = () => {
    setLoader(true)
    axios({
      method: "DELETE",
      url: `${process.env.REACT_APP_BASE_URL}/user/company/${user._id}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data:JSON.stringify({
        companyName: props.companyName,
        document: props.document
      })
    }).then(res => {
      setLoader(false)
      userStore.dispatch(updateProfile({companies:user?.companies?.filter(f => f.companyName != props.companyName && f.document != props.document) || []}));
      toast(res.data.message || "Company delete successfully", {
        theme: "light",
        position: "top-right",
        type: "success"
      });

      return props.onHide();
    }).catch(err => {
      setLoader(false)
      if (err?.response?.data?.errors) {
        toast(err?.response?.data?.errors[0].msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Company delete was unsuccessful.", {
          theme: "light",
          position: "top-right",
          type: "error"
        })
      }
    });
  }

  return (
    <>
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="red" closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Delete Company
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>Are you sure you want to delete your Company?</span>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => DeleteCompany()} className="button red" variant="primary" type="button">
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader show={loader}/>
    </>
  )
}

export default DeleteUserCompany